export const PaymentProviderMixin = {
    data() {
        return {
            PaymentProvider: {
                STRIPEID: 1,
                GIROPAYID: 2,
                PAYPALID: 3,
                GLOBALPAYMENTSID: 4,
            },
        };
    },
};